module.exports = __webpack_public_path__ + "fwm_h5/img/zhizhiLOGO.033f0252.png";